import { getConfig } from "@/constants/config"
import { apim } from "@/constants/api"

const getProductsBySkuLW = async (sku, fl) => {
  const CONFIG = await getConfig()
  const brandName = CONFIG.general?.siteName ?? ""
  const isArray = Array.isArray(sku)
  const filterSku = isArray ? sku.join('" OR "') : sku
  try {
    const res = await apim.get(`/search/plp`, {
      params: {
        fl: fl ? fl.join(",") : "*",
        q: "*:*",
        rows: isArray && sku.length > 10 ? sku.length : 10,
        profilename: `profile_${brandName.toLowerCase()}_General`,
        collections: brandName.toLowerCase(),
        fq: `sku_s:("${filterSku}")`,
        noCollapse: true
      },
    })
    if (res && res.data && res.data.response?.docs)
      return res.data.response.docs
  } catch (error) {
    console.log("Failed to fetch product details", error)
  }
  return []
}

const getProductsBySlugLW = async (slugs, fl) => {
  const CONFIG = await getConfig()
  const brandName = CONFIG.general?.siteName ?? ""
  try {
    const res = await apim.get(`/search/plp`, {
      params: {
        fl: fl ? fl.join(",") : "*",
        q: "*:*",
        rows: slugs.length > 10 ? slugs.length : 10,
        profilename: `profile_${brandName.toLowerCase()}_General`,
        collections: brandName.toLowerCase(),
        fq: `slug_s:("${slugs.join('" OR "')}")`,
      },
    })
    if (res && res.data && res.data.response?.docs)
      return res.data.response.docs
  } catch (error) {
    console.log("Failed to fetch product details", error)
  }
  return []
}

export { getProductsBySkuLW, getProductsBySlugLW }
